import I18n from 'lib/i18n'
import './styles.scss'
import React from 'react'

import { newCoursePath } from 'lib/utils/links'

import railsContext from 'lib/selectors/rails-context'
import { useSelector } from 'react-redux'

export default function TeacherSignupPromotion () {
  const { i18nLocale } = useSelector(railsContext)

  return (
    <div id='homepage-signup'>
      <div className='grid'>
        <div className='col-1-1'>
          <h2 className='homepage'>{I18n.t('react.homepage.teacher_signup.title')}</h2>
          <p>{I18n.t('react.homepage.teacher_signup.subtitle')}</p>
          <a className='button' href={newCoursePath(i18nLocale)}>
            {I18n.t('react.homepage.teacher_signup.button')}
          </a>
        </div>
      </div>
    </div>
  )
}
